import { render, staticRenderFns } from "./moduleTitle.vue?vue&type=template&id=052f076e&scoped=true&"
import script from "./moduleTitle.vue?vue&type=script&lang=js&"
export * from "./moduleTitle.vue?vue&type=script&lang=js&"
import style0 from "./moduleTitle.vue?vue&type=style&index=0&id=052f076e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052f076e",
  null
  
)

export default component.exports